import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import { departmentApplicationListTable } from "../../../shared/tableObjects/department/departmentApplicationListTable";

export default function DepartmentApplicationList() {
  const apiClient = useApiClient("DepartmentApplication");

  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Applications",
      icon: "list-icon icon-spec",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <Table apiClient={apiClient} label={""} columns={departmentApplicationListTable} route={`allDepartment`} />
      </div>
    </>
  );
}
